export default {"src":"/_next/static/media/CreatorLoginPageImageGIF.a7a373bb.gif","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};